import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const AwinPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Awin"
      description="Step-by-step instructions for submitting your Upfeed product feed to the Awin affiliate network so publishers can promote your products."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Awin</Pagetitle>
          <p>
            Follow these steps to submit your UpFeed product feed to the Awin
            affiliate network. A live product feed allows Awin publishers
            (bloggers, price comparison sites, cashback sites) to access your
            latest products and promote them via affiliate links.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>An Awin advertiser account.</li>
            </ul>
          </div>

          <h2>Submitting your product feed to Awin</h2>
          <ul>
            <li>
              Log in to your Awin advertiser account and navigate to Toolbox
              &gt; Product Feeds.
            </li>
            <li>Click 'Add a new feed'.</li>
            <li>
              Paste your product feed URL from the app in the feed URL field.
            </li>
            <li>Set the update frequency to 'Daily'.</li>
            <li>
              Map your product categories to Awin's category taxonomy if
              prompted.
            </li>
            <li>Click 'Save' to activate your feed.</li>
          </ul>

          <h2>Making your feed available to publishers</h2>
          <p>
            Once your feed is live, publishers in the Awin network can access
            your product data to feature your products on their sites. Make sure
            your feed is enabled in your Awin program settings so publishers can
            see and download it. Keeping prices and availability up to date in
            the feed is essential for affiliate compliance.
          </p>

          <RelatedPlatforms currentSlug="awin" />
        </div>
      </div>
    </div>
  </Layout>
)

export default AwinPage
